import React from 'react';

const ctaBtn = (props) => (
            <div className="ctaWrapper">
                <button onClick={props.click} className={"button " + props.classes}>{props.name}</button>
            </div>
)

export default ctaBtn;


// WEBPACK FOOTER //
// ./src/components/CtaBtn.js